<template>
  <div style="overflow: auto">
    <div id="queue-summary-view" v-if="availableQueues.length">
      <el-tabs v-model="activeTab" v-if="this.statsAvailable">
        <el-tab-pane label="Agent Activity" name="AgentActivity">
          <div class="tab-label pt-5" slot="label">
            <div>Agent Activity</div>
          </div>
          <el-row :gutter="20" class="mt-10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <h3 class="form-section-header flex align-center">
                <span style="margin-right: auto">QUEUE AGENTS</span>
                <el-select
                  v-model="agentFilter"
                  :value="agentFilter"
                  placeholder="Agents Filter"
                >
                  <el-option value="All" label="All" />
                  <el-option value="Logged In" label="Logged In" />
                  <el-option value="Logged Out" label="Logged Out" />
                </el-select>
              </h3>
              <div>
                <el-table
                  v-loading="dashboardLoading"
                  :data="agentList"
                  height="469px"
                  class="voxo-table agents-table"
                >
                  <el-table-column v-if="userIsAdmin" width="55px">
                    <template slot-scope="scope">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                          scope.row.loggedIn === 1 ? 'Logged In' : 'Logged Out'
                        "
                        placement="top"
                      >
                        <el-switch
                          :value="scope.row.loggedIn === 1"
                          @change="handleToggle(!scope.row.loggedIn, scope.row)"
                        >
                        </el-switch>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column label="" width="48px">
                    <template slot-scope="scope">
                      <el-tooltip
                        placement="left"
                        :content="agentTooltipStatus(scope.row)"
                      >
                        <el-dropdown
                          class="toolbar-avatar"
                          placement="bottom-start"
                          trigger="click"
                          v-if="userIsAdmin"
                        >
                          <div class="avatar-group" style="">
                            <div class="contact-avatar" v-if="scope.row.avatar">
                              <img
                                :src="scope.row.avatar"
                                :alt="scope.row.membername"
                                :title="scope.row.membername"
                              />
                            </div>
                            <div class="contact-avatar" v-else>
                              {{
                                scope.row.membername
                                  .substring(0, 1)
                                  .toUpperCase()
                              }}
                            </div>
                            <div class="status-light">
                              <status-indicator
                                :pulse="false"
                                :status="
                                  getStatusFromEvent(scope.row.extStatus)
                                "
                              >
                              </status-indicator>
                            </div>
                            <div class="dnd-icon" v-if="scope.row.dnd === 'on'">
                              <hr />
                              <status-indicator></status-indicator>
                            </div>
                          </div>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                              v-if="
                                user.myExtension.number !=
                                  scope.row.extension &&
                                softphoneEnabled &&
                                canListenCoach
                              "
                            >
                              <div @click="dialCall(scope.row.extension)">
                                <v-svg class="voxo-green" sprite="phone" />
                                Call
                              </div>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="scope.row.loggedIn">
                              <div v-if="!scope.row.paused">
                                <!--                                <v-svg class="voxo-orange" sprite="pause-2"/>
                                Pause-->
                                <el-radio-group
                                  v-model="pauseMenuReason"
                                  @change="
                                    (value) =>
                                      handlePauseReasonChange(value, scope.row)
                                  "
                                >
                                  <el-radio
                                    class="black-text mt-10"
                                    v-for="(item, index) in pauseReasons"
                                    :key="index"
                                    :label="item"
                                    style="display: block; margin-left: 0"
                                  />
                                </el-radio-group>
                              </div>
                              <div v-else @click="unpauseMember(scope.row)">
                                <v-svg class="voxo-orange" sprite="pause-2" />
                                Unpause
                              </div>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="scope.row.dnd === 'on'">
                              <div @click="disableDND(scope.row)">
                                <v-svg
                                  class="voxo-dark-red"
                                  sprite="call-block"
                                ></v-svg>
                                Disable DND
                              </div>
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                        <div
                          v-else
                          class="avatar-group"
                          style="margin-left: 5px; padding-top: 5px"
                        >
                          <div class="contact-avatar" v-if="scope.row.avatar">
                            <img
                              :src="scope.row.avatar"
                              :alt="scope.row.membername"
                              :title="scope.row.membername"
                            />
                          </div>
                          <div class="contact-avatar" v-else>
                            {{
                              scope.row.membername.substring(0, 1).toUpperCase()
                            }}
                          </div>
                          <div class="status-light">
                            <status-indicator
                              :pulse="false"
                              :status="getStatusFromEvent(scope.row.extStatus)"
                            >
                            </status-indicator>
                          </div>
                          <div class="dnd-icon" v-if="scope.row.dnd === 'on'">
                            <hr />
                            <status-indicator></status-indicator>
                          </div>
                        </div>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="membername"
                    label="Name"
                    width="225px"
                    sortable
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.lastPauseReason"
                        placement="top"
                        v-if="+scope.row.paused"
                      >
                        <div
                          class="agent-name flex align-center justify-flex-start"
                        >
                          {{ agentNameFormatter(scope.row.membername) }}
                          <v-svg
                            class="voxo-orange pause-icon"
                            :sprite="getPauseIcon(scope.row.lastPauseReason)"
                          ></v-svg>
                        </div>
                      </el-tooltip>
                      <div
                        v-if="!+scope.row.paused"
                        class="agent-name flex align-center justify-flex-start"
                      >
                        {{ agentNameFormatter(scope.row.membername) }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="inboundTotal"
                    label="In"
                    width="55px"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    prop="outboundTotal"
                    label="Out"
                    width="65px"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    prop="refusedCalls"
                    label="Refused"
                    width="90px"
                    sortable
                  >
                    <template slot-scope="scope">
                      {{ scope.row.refusedCalls ? scope.row.refusedCalls : 0 }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Time In/Out"
                    :formatter="getTimeFormat"
                    width="125px"
                    sortable
                  >
                    <template slot-scope="scope"
                      >{{ convertTime(scope.row.inboundTalkTime) }}/{{
                        convertTime(scope.row.outboundTalkTime)
                      }}</template
                    >
                  </el-table-column>
                  <el-table-column
                    prop="pauseTime"
                    label="Pause Time"
                    :formatter="getTimeFormat"
                    sortable
                  >
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <h3 class="form-section-header pl-10 pt-10 pb-5">QUEUE STATS</h3>
              <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <div
                    class="card-base card-shadow--medium mb-30 widget small-widget"
                    v-loading="false"
                  >
                    <div class="widget-header ph-20 pb-10 mb-10">
                      <div class="stats-flex-body">
                        <h3 class="stat-header widget-title text-truncate">
                          <v-svg class="voxo-purple" sprite="group" />
                          <span class="pl-10"> AGENTS:CALLERS </span>
                        </h3>
                        <h1
                          class="m-0 text-truncate voxo-blue text-center stat-number"
                        >
                          <span
                            :class="
                              liveCalls > agentCount ? 'voxo-dark-red' : ''
                            "
                            >{{ agentCount }}:{{ liveCalls }}</span
                          >
                        </h1>
                        <div class="stats-sub"></div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <div
                    class="card-base card-shadow--medium mb-30 widget small-widget"
                    v-loading="false"
                  >
                    <div class="widget-header ph-20 pb-10 mb-10">
                      <div class="stats-flex-body">
                        <h3 class="stat-header widget-title text-truncate">
                          <v-svg class="voxo-orange" sprite="clock" />
                          <span class="pl-10"> AGENTS READY </span>
                        </h3>
                        <h1
                          class="m-0 text-truncate voxo-blue text-center stat-number"
                        >
                          <span>{{ readyAgents }}</span>
                        </h1>
                        <div class="stats-sub"></div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <div
                    class="card-base card-shadow--medium widget small-widget"
                    v-loading="false"
                  >
                    <div class="widget-header ph-20 pb-10 mb-10">
                      <div class="stats-flex-body">
                        <h3 class="stat-header widget-title text-truncate">
                          <v-svg class="voxo-green" sprite="clock" />
                          <span class="pl-10"> ACTIVE CALLS </span>
                        </h3>
                        <h1
                          class="m-0 text-truncate voxo-blue text-center stat-number"
                        >
                          <span>{{ activeCalls }}</span>
                        </h1>
                        <div class="stats-sub"></div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <div
                    class="card-base card-shadow--medium widget small-widget"
                    v-loading="false"
                  >
                    <div class="widget-header ph-20 pb-10 mb-10">
                      <div class="stats-flex-body">
                        <h3 class="stat-header widget-title text-truncate">
                          <v-svg class="voxo-dark-red" sprite="group" />
                          <span class="pl-10"> CALLS WAITING </span>
                        </h3>
                        <h1
                          class="m-0 text-truncate voxo-blue text-center stat-number"
                        >
                          <span>{{ waitingCalls }}</span>
                        </h1>
                        <div class="stats-sub"></div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="mt-20" :gutter="30">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <h3 class="form-section-header">ACTIVE CALLS</h3>
              <el-table
                :data="connectedCalls"
                height="500px"
                class="voxo-table agent-calls"
                :default-sort="{ prop: 'agent', order: 'ascending' }"
              >
                <el-table-column
                  v-if="userIsAdmin && canListenCoach && softphoneEnabled"
                  width="80"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="Listen"
                      placement="left"
                    >
                      <el-button
                        class="manager-action-button"
                        :disabled="scope.row.channelState !== 'Up'"
                        @click="callSpyRequest(scope.row, false)"
                      >
                        <v-svg class="voxo-blue" sprite="eye"></v-svg>
                      </el-button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="Coach"
                      placement="right"
                    >
                      <el-button
                        class="manager-action-button"
                        :disabled="scope.row.channelState !== 'Up'"
                        @click="callSpyRequest(scope.row, true)"
                      >
                        <v-svg class="voxo-pink" sprite="hearing"></v-svg>
                      </el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Agent"
                  prop="agent"
                  :formatter="nameFormatter"
                >
                </el-table-column>
                <el-table-column prop="cidname" label="Name" sortable>
                </el-table-column>
                <el-table-column
                  prop="cidnum"
                  label="Number"
                  :formatter="numberFormatter"
                >
                </el-table-column>
                <el-table-column label="Duration">
                  <template slot-scope="scope">
                    <span class="call-badge text-left">
                      <el-tooltip
                        effect="dark"
                        content="Inbound"
                        placement="right"
                        v-if="scope.row.direction === 'recipient'"
                      >
                        <el-badge
                          :value="convertTimeDuration(scope.row.duration)"
                          class="item"
                          type="success"
                        ></el-badge>
                      </el-tooltip>
                      <el-tooltip
                        effect="dark"
                        content="Outbound"
                        placement="right"
                        v-if="scope.row.direction === 'initiator'"
                      >
                        <el-badge
                          :value="convertTimeDuration(scope.row.duration)"
                          class="item"
                          type="primary"
                        ></el-badge>
                      </el-tooltip>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <h3 class="form-section-header">CALLS WAITING</h3>
              <el-table
                :data="queueCallers"
                :default-sort="{ prop: 'position', order: 'ascending' }"
                height="500px"
                class="voxo-table agent-calls"
              >
                <el-table-column
                  type="index"
                  width="30"
                  align="center"
                  sortable
                />
                <el-table-column
                  v-if="softphoneEnabled"
                  width="80"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="Pick up"
                      placement="left"
                    >
                      <el-button
                        v-if="!scope.row.channel.includes('Local') && allowCallPickup"
                        class="manager-action-button"
                        @click="withdrawCaller(scope.row)"
                      >
                        <v-svg class="voxo-green" sprite="call-bounce"></v-svg>
                      </el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="calleridname" label="Name" sortable />
                <el-table-column
                  prop="calleridnum"
                  label="Number"
                  :formatter="numberFormatter"
                >
                </el-table-column>
                <el-table-column prop="agentRinging" label="Ringing">
                </el-table-column>
                <el-table-column label="Time" :formatter="getTimeFormatHold">
                  <template slot-scope="scope">
                    <el-badge
                      :value="getTimeFormatHold(scope.row.wait)"
                      class="item"
                      type="success"
                      v-show="scope.row.wait <= 30"
                    ></el-badge>
                    <el-badge
                      :value="getTimeFormatHold(scope.row.wait)"
                      class="item"
                      type="warning"
                      v-show="scope.row.wait > 30 && scope.row.wait <= 60"
                    ></el-badge>
                    <el-badge
                      :value="getTimeFormatHold(scope.row.wait)"
                      class="item"
                      type="danger"
                      v-show="scope.row.wait > 60"
                    ></el-badge>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane
          label="Dashboard"
          name="Statistics"
          v-loading="dashboardLoading"
        >
          <div class="tab-label pt-5" slot="label">
            <div>Dashboard</div>
          </div>
          <el-row class="mt-20" :gutter="30">
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <div
                class="card-base card-shadow--medium mb-30 widget small-widget"
              >
                <div class="widget-header ph-20 pb-10 mb-10">
                  <div class="stats-flex-body fadeInLeft">
                    <h3 class="stat-header widget-title text-truncate">
                      <v-svg
                        width="18"
                        height="18"
                        class="voxo-green"
                        sprite="call-inbound"
                      />
                      <span class="pl-10">COMPLETED CALLS</span>
                    </h3>
                    <h1
                      class="m-0 text-truncate voxo-blue text-center stat-number"
                    >
                      {{ completedCalls }}
                    </h1>
                    <div class="stats-sub">
                      <div class="sub-stat-group">
                        <div class="sub-stat-number">
                          {{ inboundComplete }}
                        </div>
                        <div class="sub-stat-title">INBOUND</div>
                      </div>
                      <div class="sub-stat-group">
                        <div class="sub-stat-number text-right">
                          {{ outboundComplete }}
                        </div>
                        <div class="sub-stat-title">OUTBOUND</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <div
                class="card-base card-shadow--medium mb-30 widget small-widget"
                v-loading="false"
              >
                <div class="widget-header ph-20 pb-10 mb-10">
                  <div class="stats-flex-body">
                    <h3 class="stat-header widget-title text-truncate">
                      <v-svg class="voxo-purple" sprite="group" />
                      <span class="pl-10"> AGENTS:CALLERS </span>
                    </h3>
                    <h1
                      class="m-0 text-truncate voxo-blue text-center stat-number"
                    >
                      <span :class="liveCalls > agentCount ? 'voxo-red' : ''"
                        >{{ agentCount }}:{{ liveCalls }}</span
                      >
                    </h1>
                    <div class="stats-sub"></div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <div
                class="card-base card-shadow--medium mb-30 widget small-widget"
              >
                <div class="widget-header ph-20 pb-10 mb-10">
                  <div class="stats-flex-body">
                    <h3 class="stat-header widget-title text-truncate">
                      <v-svg class="voxo-blue" sprite="clock" />
                      <span class="pl-10"> TOTAL TALK TIME </span>
                    </h3>
                    <h1
                      class="m-0 text-truncate voxo-blue text-center stat-number"
                    >
                      {{ convertTime(callDuration) }}
                    </h1>
                    <div class="stats-sub">
                      <div class="sub-stat-group">
                        <div class="sub-stat-number">
                          {{ convertTime(inboundTalkTime) }}
                        </div>
                        <div class="sub-stat-title">INBOUND</div>
                      </div>
                      <div class="sub-stat-group">
                        <div class="sub-stat-number text-right">
                          {{ convertTime(outboundTalkTime) }}
                        </div>
                        <div class="sub-stat-title">OUTBOUND</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <div
                class="card-base card-shadow--medium mb-30 widget small-widget"
                v-loading="false"
              >
                <div class="widget-header ph-20 pb-10 mb-10">
                  <div class="stats-flex-body">
                    <h3 class="stat-header widget-title text-truncate">
                      <v-svg class="voxo-dark-red" sprite="clock" />
                      <span class="pl-10"> TOTAL WAIT TIME </span>
                    </h3>
                    <h1
                      class="m-0 text-truncate voxo-blue text-center stat-number"
                    >
                      {{ convertTime(waitTime) }}
                    </h1>
                    <div class="stats-sub">
                      <div class="sub-stat-group">
                        <div class="sub-stat-number">
                          {{ shortestWait ? convertTime(shortestWait) : 0 }}
                        </div>
                        <div class="sub-stat-title">SHORTEST</div>
                      </div>
                      <div class="sub-stat-group">
                        <div class="sub-stat-number text-right">
                          {{ longestWait ? convertTime(longestWait) : 0 }}
                        </div>
                        <div class="sub-stat-title">LONGEST</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :xs="24" :sm="24" :md="24" :lg="18" :xl="18">
              <call-volume-plot
                :plotData="hourlyMetrics"
                :plotLoading="plotLoading"
                @updatePlot="updatePlotData"
              >
              </call-volume-plot>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <div
                class="card-base card-shadow--medium mb-30 widget small-widget"
                v-loading="false"
              >
                <div class="widget-header ph-20 pb-10 mb-10">
                  <div class="stats-flex-body">
                    <h3 class="stat-header widget-title text-truncate">
                      <v-svg class="voxo-green" sprite="check" />
                      <span class="pl-10">COMPLETED SLA ( 30s )</span>
                    </h3>
                    <h1
                      class="m-0 text-truncate voxo-blue text-center stat-number"
                    >
                      {{ totalSLA }}
                    </h1>
                    <div class="stats-sub">
                      <div class="sub-stat-group">
                        <div class="sub-stat-number">
                          {{
                            servicelevelperf
                              ? (servicelevelperf * 100).toFixed(0) + " %"
                              : 0
                          }}
                        </div>
                        <div class="sub-stat-title">SERVICE LEVEL</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="card-base card-shadow--medium mb-30 widget small-widget"
                v-loading="false"
              >
                <div class="widget-header ph-20 pb-10 mb-10">
                  <div class="stats-flex-body">
                    <h3 class="stat-header widget-title text-truncate">
                      <v-svg class="voxo-dark-red" sprite="call-inbound" />
                      <span class="pl-10"> ABANDONED CALLS </span>
                    </h3>
                    <h1
                      class="m-0 text-truncate voxo-blue text-center stat-number"
                    >
                      {{ abandonedCalls }}
                    </h1>
                    <div class="stats-sub">
                      <div class="sub-stat-group">
                        <div class="sub-stat-number">
                          {{
                            abandonRate
                              ? (abandonRate * 100).toFixed(0) + " %"
                              : 0
                          }}
                        </div>
                        <div class="sub-stat-title">ABANDON RATE</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div v-else v-loading="dashboardLoading" class="mt-30">
        The Selected Tenant Has No Available Queue Data!
      </div>
    </div>

    <div v-else>The selected account has no available queues.</div>

    <el-dialog
      class="form-modal"
      :visible.sync="pauseReasonVisible"
      :close-on-press-escape="false"
      :show-close="false"
      :close-on-click-modal="false"
      :modal="false"
    >
      <el-form>
        <h2 class="form-section-header">Agent Pause Reason</h2>
        <el-input
          type="text"
          v-model="otherPauseReason"
          placeholder="Enter Other"
        >
          <template class="label-prefix" slot="prefix">Other Reason</template>
        </el-input>
        <div class="inline-form-group justify-flex-end">
          <el-button @click="processPause"> Submit </el-button>
          <el-button @click="cancelPause"> Cancel </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CallVolumePlot from "./components/call-volume-plot";
import feathersClient, { apiV2Host } from "../../../feathers/feathers-client";
import { mapActions, mapGetters } from "vuex";
import { globalEventBus } from "@/globalEventBus";
import pauseIcons from "../../../ref/pause-icons";
import extensionStatus from "../../../ref/extension-status";
import moment from "moment-timezone";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "OMNIAQueues",
  components: { CallVolumePlot },
  data() {
    return {
      payloadTimeStamp: null,
      pageLoadTime: moment().format("YYYY-MM-DD"),
      sessionStart: moment().format("YYYY-MM-DD HH:mm:ss"),
      sessionPoller: null,
      activeOutbounds: [],
      statResetComplete: false,
      resetPoller: null,
      activeTab: "AgentActivity",
      agentFilter: "Logged In",
      statsAvailable: false,
      pausePoller: null,
      callLeader: null,
      totalCalls: 0,
      completedCalls: 0,
      inboundCalls: 0,
      inboundComplete: 0,
      outboundComplete: 0,
      callDuration: 0,
      inboundTalkTime: 0,
      outboundTalkTime: 0,
      waitTime: 0,
      shortestWait: 0,
      longestWait: 0,
      hourlyMetrics: null,
      totalSLA: 0,
      servicelevelperf: 0,
      abandonedCalls: 0,
      abandonRate: 0,
      queueChannel: null,
      statusChannel: null,
      holdCounter: null,
      waitingCalls: 0,
      activeCalls: 0,
      liveCalls: 0,
      dashboardLoading: true,
      pauseReasonVisible: false,
      pauseReason: "",
      otherPauseReason: "",
      pauseAgent: "",
      pauseType: "",
      pausedAgents: [],
      plotLoading: false,
      pauseReasons: [
        "Account Review",
        "Break",
        "Lunch",
        "Meeting",
        "Personal",
        "Other",
      ],
      pauseMenuReason: "",
      activeCallPoller: null,
      waitingCallPoller: null
    };
  },
  computed: {
    ...mapGetters("queues", { queueList: "find" }),
    ...mapGetters("queuemembers", {
      findQueueMembers: "find",
      getQueueAgent: "get",
    }),
    ...mapGetters("queuecallers", {
      queueCallerList: "find",
      getCallWaiting: "get",
    }),
    ...mapGetters("currentcalls", {
      currentCallList: "find",
      getCurrentCall: "get",
    }),
    user() {
      return this.$store.state.auth.user;
    },
    userHostServer() {
      return this.$store.state.userHostServer;
    },
    userIsAdmin() {
      if (this.user) {
        const adminRoles = [1, 3, 11, 12];

        if (adminRoles.includes(+this.user.userRole)) {
          return true;
        }

        if (+this.user.userRole === 7) {
          const { adminQueues } = this.user;
          return adminQueues.includes(this.selectedQueue.id);
        }

        return adminRoles.includes(+this.user.userRole);
      }
    },
    canListenCoach() {
      if (this.user) {
        if (this.user.hasOwnProperty("myExtension")) {
          return this.user.myExtension.tenantId === this.selectedTenant.id;
        }
      }
      return false;
    },
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    availableQueues() {
      return this.$store.state.queueList;
    },
    selectedQueue() {
      return this.$store.state.selectedQueue;
    },
    agentList() {
      switch (this.agentFilter) {
        case "All":
          return this.findQueueMembers({ query: { $sort: { callOrder: 1 } } })
            .data;
        case "Logged In":
          return this.findQueueMembers({
            query: { loggedIn: 1, $sort: { callOrder: 1 } },
          }).data;
        case "Logged Out":
          return this.findQueueMembers({
            query: { loggedIn: 0, $sort: { callOrder: 1 } },
          }).data;
        default:
          return this.findQueueMembers({ query: { $sort: { callOrder: 1 } } })
            .data;
      }
    },
    agentCount() {
      return this.findQueueMembers({
        query: {
          loggedIn: 1,
          paused: { $ne: 1 },
          extStatus: { $ne: "UNAVAILABLE" },
          dnd: { $ne: "on" },
        },
      }).data.length;
    },
    readyAgents() {
      return this.findQueueMembers({
        query: {
          loggedIn: 1,
          extStatus: "NOT_INUSE",
          paused: { $ne: 1 },
          dnd: { $ne: "on" },
        },
      }).data.length;
    },
    queueCallers() {
      return this.queueCallerList().data;
    },
    connectedCalls() {
      this.waitingCalls = this.queueCallerList().data.length;
      const callList = this.currentCallList().data;
      this.activeCalls = callList.length;
      this.liveCalls = this.activeCalls + this.waitingCalls;
      return callList;
    },
    softphoneEnabled() {
      return this.$store.state.softphoneEnabled;
    },
    userOffsetMinutes() {
      return this.$store.state.userTimeOffset;
    },
    lastDashboardQueue() {
      return this.$store.state.lastDashboardQueue;
    },
    globalQueueActions() {
      if (this.selectedTenant) {
        return !!this.selectedTenant.globalQueueActions;
      }
      return false;
    },
    allowCallPickup(){
      if(this.user){

        if(+this.user.userRole === 7){
          return true;
        }

        if(this.selectedQueue && [1,3,5,9,11,12].includes(+this.user.userRole) && this.selectedTenant.id === this.user.tenantId){
          return !!this.selectedQueue.agentPickup;
        }
      }

      return false;
    }
  },
  watch: {
    async selectedQueue() {

      clearInterval(this.activeCallPoller);
      clearInterval(this.waitingCallPoller);
      this.activeCallPoller = null
      this.waitingCallPoller = null;

      if (this.selectedQueue.id) {
        this.dashboardLoading = true;
        const queryQueueId = this.selectedQueue.id;

        //clean up the store data
        this.$store.commit("setLastDashboardQueue", queryQueueId);
        this.$store.commit("queuemembers/clearList");
        this.$store.commit("queuecallers/clearList");
        this.$store.commit("currentcalls/clearList");

        //initial load for the dashboard stats
        await this.querySummary();
        this.dashboardLoading = false;

        //join the important real time event channels
        await this.joinSocketChannel();

        // get the list of nonconnected calls
        if(!this.waitingCallPoller){
          await this.getNonconnectedQueues();
        }

        if(this.waitingCallPoller){
          clearInterval(this.waitingCallPoller);
          this.waitingCallPoller = null;
        }

        this.waitingCallPoller = setInterval(() => {
          this.getNonconnectedQueues();
        }, 5000);

        //grab the currently active calls for the queue
        if(!this.activeCallPoller){
          await this.getActiveCalls();
        }

        if(this.activeCallPoller){
          clearInterval(this.activeCallPoller);
          this.activeCallPoller = null;
        }

        this.activeCallPoller = setInterval(() => {
          this.getActiveCalls();
        }, 5000);
      }
    },
    statsAvailable() {
      this.statsAvailable
        ? this.$store.commit("setActiveQueue", true)
        : this.$store.commit("setActiveQueue", false);
    },
    user() {
      this.queryQueues();
    },
  },
  methods: {
    ...mapActions("queues", { findQueues: "find" }),
    async getActiveCalls() {
      const queryQueueId = this.selectedQueue.id;

      const peerNames = this.user.myExtension.peerName
        ? [
            ...this.$store.state.queuemembers.ids,
            this.user.myExtension.peerName,
          ]
        : [...this.$store.state.queuemembers.ids];

      const channels = await feathersClient
        .service("nats-actions-handler")
        .create({
          reqType: "refreshQueueConnected",
          queueId: queryQueueId,
          server: this.userHostServer,
          peerName: this.user.myExtension.peerName,
          tenantCode: this.selectedTenant.tenantCode,
          tenantId: this.selectedTenant.id,
          userId: this.user.id,
          userExten: this.user.myExtension.number,
          peerNames,
        });

      this.$store.commit('currentcalls/clearList');
      const callsCount = channels.length;
      for (let i = 0; i < callsCount; i++) {
        const theChannel = channels[i];

        if (!this.checkCallExists(theChannel)) {
          const {
            channel,
            exten,
            connectedlinenum,
            connectedlinename,
            direction,
            timestamp,
            hostName,
            peerName,
            channelstatedesc,
            application
          } = theChannel;
          const queueMember = this.getQueueAgent(peerName);

          // don't push spy and whisper into the live call view
          if(connectedlinenum.includes("SPY") || connectedlinenum.includes("WHISPER")){
            continue;
          }

          if (
            queueMember &&
            application !== "ChanSpy"
          ) {
            //this should be added to active outbounds if it is an outbound
            if (direction === "initiator") {
              this.activeOutbounds.push({
                startTime: moment().format("YYYY-MM-DD HH:mm:ss"),
                channel,
                duration: moment().unix() - timestamp,
                cidnum: connectedlinenum,
              });
            }

            //if the user is logged in this call should push into the store to render in active calls
            if (connectedlinenum.length && +queueMember.loggedIn) {
              const callData = {
                agent: queueMember.membername,
                channel,
                cidnum: connectedlinenum,
                cidname: connectedlinename,
                direction,
                peername: peerName,
                systemname: hostName,
                channelState: channelstatedesc,
                duration: moment().unix() - timestamp,
                application,
                agentName: queueMember.membername.replace("_", " "),
                isActiveChannel: true,
              };
              this.$store.commit("currentcalls/addItem", callData);
            }
          }
        }
      }
    },
    async getNonconnectedQueues() {
      const queryQueueId = this.selectedQueue.id;
      let res = await feathersClient
        .service("nats-actions-handler")
        .create({
          reqType: "queueStatus",
          queueId: queryQueueId,
          server: this.userHostServer,
          tenantCode: this.selectedTenant.tenantCode,
        })
        .catch((e) => console.log(e));

/*      res =    [{
        "entryTime": 1685111640,
        "now": 1685112347,
        "queueId": 298,
        "channel": "PJSIP/main-0000f626",
        "connected": 0,
        "position": 3,
        "calleridname": "MEINBERG SCOTT",
        "calleridnum": "2053821727",
        "priority": 0,
        "connectTime": null,
        "systemname": "ast-d8c5f67dc-97kx6"
      }];*/

      this.$store.commit('queuecallers/clearList');
      for (let x = 0; x < res.length; x++) {
        const { channel } = res[x];

        const call = this.getCallWaiting(channel);

        if (!call) {
          this.$store.commit("queuecallers/addItem", res[x]);
          res[x].isQueueEntry = true;
          this.updateAgentRinging(res[x]);
        }
      }
    },
    queryQueues() {
      if (!this.userIsAdmin || +this.user.userRole === 7) {
        let allowedQueues = this.user.myExtension.queueIds;
        if (+this.user.userRole === 7) {
          const { adminQueues } = this.user;
          allowedQueues = [...allowedQueues, ...adminQueues];
        }

        this.findQueues({
          query: {
            id: { $in: allowedQueues },
            tenantId: this.selectedTenant.id,
            $sort: { name: 1 },
          },
        }).then((res) => {
          this.$store.commit("setQueues", res);
          this.loadQueues(res);
        });
      } else {
        this.findQueues({
          query: {
            tenantId: this.selectedTenant.id,
            $sort: { name: 1 },
          },
        }).then((res) => {
          this.$store.commit("setQueues", res);
          this.loadQueues(res);
        });
      }
    },

    loadQueues(data) {
      //check local storage for cached queue id
      //if null or id match not found set to first in list
      if (data.length) {
        if (this.lastDashboardQueue) {
          let queueFound = 0;
          for (let i = 0; i < data.length; i++) {
            if (data[i].id === this.lastDashboardQueue) {
              this.$store.commit("setSelectedQueue", data[i]);
              this.$store.commit("setLastDashboardQueue", data[i].id);
              queueFound = 1;
              break;
            }
          }
          if (!queueFound) {
            this.$store.commit("setSelectedQueue", data[0]);
            this.$store.commit("setLastDashboardQueue", data[0].id);
          }
        } else {
          this.$store.commit("setSelectedQueue", data[0]);
          this.$store.commit("setLastDashboardQueue", data[0].id);
        }
      } else {
        this.statsAvailable = false;
      }
    },

    async querySummary() {

      if(!this.selectedQueue.id){
        this.statsAvailable = false;
        return;
      }

      if (this.selectedQueue.id) {
        const queryQueue = this.selectedQueue.id;
        this.dashboardLoading = true;

        //request current stats payload.
        const queueStatsRes = await feathersClient
          .service("queue-stats")
          .find({
            query: {
              command: "summary",
              queueId: queryQueue,
              timezone: this.user.timezone,
            },
          })
          .catch((e) => console.log(e));

        if(!queueStatsRes.hasOwnProperty(queryQueue)){
          this.statsAvailable = false;
          return;
        }

        const queueStats = queueStatsRes[queryQueue];
        this.statsAvailable = !!Object.keys(queueStats).length;
        this.populateStats(queueStats);
        this.$store.commit(
          "queuemembers/addItems",
          queueStatsRes[queryQueue].agents
        );
        this.gatherPaused(queueStatsRes[queryQueue].agents);

        if (this.user.hasOwnProperty("myExtension")) {
          const omniaAgent = this.getQueueAgent(
            this.user.myExtension.peerName
          );
          if (omniaAgent) {
            this.$store.commit("setQueueLoggedIn", omniaAgent.loggedIn === 1);
            this.$store.commit("setQueuePaused", omniaAgent.paused === 1);
            this.$store.commit(
              "setQueuePausedReason",
              omniaAgent.paused ? omniaAgent.lastPauseReason : ""
            );
          }
        }

        //payload timestamp
        this.payloadTimeStamp = moment().format("YYYY-MM-DD HH:mm:ss")
      }
    },

    populateStats(stats) {
      for (let key in stats) {
        if (stats.hasOwnProperty(key)) {
          this[key] = stats[key];
        }
      }
    },

    async updatePlotData() {
      const queryQueue = this.selectedQueue.id;
      this.plotLoading = true;
      const queueStatsRes = await feathersClient
        .service("queue-stats")
        .find({
          query: {
            command: "summary",
            queueId: queryQueue,
            timezone: this.user.timezone,
          },
        })
        .catch((e) => console.log(e));
      this.plotLoading = false;
      if (queueStatsRes.hasOwnProperty(queryQueue)) {
        this.hourlyMetrics = queueStatsRes[queryQueue].hourlyMetrics;
      }
    },

    convertTime(time) {
      const hours = Math.floor(time / 3600);
      const remainderSeconds = time % 3600;
      const minutes = Math.floor(remainderSeconds / 60);
      const seconds = Math.round(remainderSeconds % 60);

      if (hours > 0) {
        return hours + "hr " + minutes + "m";
      }
      if (minutes > 0) {
        return minutes + "m";
      }
      if (seconds > 0) {
        return seconds + "s";
      }
      return "0";
    },

    convertTimeDuration(time) {
      const hours = Math.floor(time / 3600);
      const remainderSeconds = time % 3600;
      const minutes = Math.floor(remainderSeconds / 60);
      const seconds = Math.round(remainderSeconds % 60);

      if (hours > 0) {
        return hours + "hr " + minutes + "m";
      }
      if (minutes > 0) {
        return minutes + "m " + seconds + "s";
      }
      if (seconds > 0) {
        return seconds + "s";
      }
      return "0";
    },

    getTimeFormat(row, column, value, index) {
      return this.convertTime(value);
    },

    getTimeFormatHold(time) {
      return this.convertTimeDuration(time);
    },

    nameFormatter(row, column, value, index) {
      return value ? value.replace(/[_]{1}/g, " ") : value;
    },

    agentNameFormatter(name) {
      return name ? name.replace(/[_]{1}/g, " ") : name;
    },

    numberFormatter(row, column, value) {
      return value ? phoneNumberFormatter(value) : value;
    },

    async joinSocketChannel() {
      const channelService = feathersClient.service("channel-memberships");

      //leave the old queue channel before we join the new one
      if (this.queueChannel) {
        await channelService.remove(null, {
          query: { channelName: this.queueChannel },
        });
      }

      //joins real time channel for the selected queue
      const dataChannel = {
        roomType: "queues",
        queueId: this.selectedQueue.id,
      };

      await channelService.create(dataChannel).then((res) => {
        this.queueChannel = `${dataChannel.roomType}/${dataChannel.queueId}`;
      });

      //leave old status channel before we join the new one
      if (this.statusChannel) {
        await channelService.remove(null, {
          query: { channelName: this.statusChannel },
        });
      }

      //join the real time channel for extension status
      const statusChannel = {
        roomType: "extensions",
        tenantCode: this.selectedTenant.tenantCode,
      };

      await channelService.create(statusChannel).then((res) => {
        this.statusChannel = `${statusChannel.roomType}/${statusChannel.tenantCode}`;
      });
    },
    removeListeners() {
      //removes all event listeners local to this view as to not produce duplicates later
      const channelService = feathersClient.service("channel-memberships");
      channelService.removeListener("queueRefresh");
      channelService.removeListener("queueMemberPause");
      // channelService.removeListener("queueCallerJoin");
      // channelService.removeListener("queueCallLeave");
      // channelService.removeListener("queueCallerConnected");
      // channelService.removeListener("queueEntry");
      channelService.removeListener("queueAbandon");
      channelService.removeListener("agentRefused");
      channelService.removeListener("agentComplete");
      channelService.removeListener("extensionStatus");
      channelService.removeListener("notifyExtStatus");
      channelService.removeListener("showMeYourQueueStats");
      channelService.removeListener("userShowingQueueStats");
      clearInterval(this.holdCounter);
      clearInterval(this.pausePoller);
      clearInterval(this.resetPoller);
      clearInterval(this.sessionPoller);
      clearInterval(this.waitingCallPoller);
      clearInterval(this.activeCallPoller);
      globalEventBus.$off([
        "appReconnected",
        "queuePauseToggled",
        "queueLoginToggled",
      ]);
    },

    getStatusFromEvent(code) {
      return extensionStatus(code);
    },

    gatherPaused(agents) {
      const pausedAgents = agents.filter((item) => !!+item.paused);
      this.pausedAgents = pausedAgents.map((item) => item.member_device);
    },

    updateMember(member, evt) {
      const { member_device } = member;
      const { peername, status, direction, cidname, cidnum, dnd } = evt;

      let updateObject = { member_device };

      //check and see if this member has connected call. if so they are INUSE so force it
      const memberCalls = this.currentCallList({ query: { peername } }).data;

      //enforce in use if calls returned. otherwise update status to event status
      updateObject.extStatus = memberCalls.length ? "INUSE" : status;

      //connected call info
      if (direction.length) {
        if (cidnum.length && cidnum !== "<unknown>") {
          updateObject.connected = `${cidname} - ${cidnum}`;
          updateObject.direction = direction;
        }
      } else {
        updateObject.connected = "";
        updateObject.direction = "";
        updateObject.dnd = dnd;
      }

      this.$store.commit("queuemembers/updateItem", updateObject);
    },

    updateMemberPause(evt) {
      const { peerName, paused, reason } = evt;
      const { timezone } = this.user;

      //find the queue agent in the store
      const agent = this.getQueueAgent(peerName);

      if (agent) {
        let updateData = {
          member_device: agent.member_device,
          pauseTime: agent.pauseTime,
          paused: +paused,
        };

        //agent paused. need to mark last pause time and push to poller array.
        if (+paused) {
          updateData.lastPauseTime = moment
            .tz(timezone)
            .format("YYYY-MM-DD HH:mm:ss");
          updateData.lastPauseReason = reason;
          this.pausedAgents.push(updateData.member_device);
        }

        //agent unpaused. need to calculate new total pause time and remove from poller array.
        if (!+paused) {
          this.pausedAgents = this.pausedAgents.filter(
            (item) => item !== updateData.member_device
          );

          //some tz work is required here to be sure things update properly.
          const offsetUser = moment().utcOffset();
          const offsetTZ = moment.tz(timezone).utcOffset();
          const realOffset = offsetTZ - offsetUser;
          const offsetMinutes = Math.abs(realOffset);

          const now =
            realOffset < 0
              ? moment().subtract(offsetMinutes, "minutes")
              : moment().add(offsetMinutes, "minutes");

          const lastPause = moment(agent.lastPauseTime);
          const diffInSecs = now.diff(lastPause, "seconds");
          updateData.pauseTime += +diffInSecs;
        }

        //update the queue member in the store.
        this.$store.commit("queuemembers/updateItem", updateData);

        //update local loggedIn state if user getting update is the actual agent
        if (this.user.hasOwnProperty("myExtension")) {
          if (agent.member_device === this.user.myExtension.peerName) {
            this.$store.commit("setQueuePaused", +paused === 1);
            if (+paused) {
              this.$store.commit("setQueuePausedReason", reason);
            } else {
              this.$store.commit("setQueuePausedReason", "");
            }
          }
        }
      }
    },

    updateAgentInbound(data) {
      const { peerName, duration } = data;
      const agent = this.getQueueAgent(peerName);
      if (agent) {
        const agentCopy = { ...agent };
        agentCopy.inboundTotal++;
        agentCopy.inboundTalkTime += +duration;
        this.$store.commit("queuemembers/updateItem", agentCopy);
      }
    },

    updateAgentOutbound(agent, call, isAnswered) {
      const activeOutbound = this.activeOutbounds.find(
        (item) => item.channel === call && item.cidnum !== "<unknown>"
      );

      if (activeOutbound) {
        const { startTime, duration, cidnum, channel } = activeOutbound;
        const agentCopy = { ...agent };

        if (cidnum.length > 9) {
          agentCopy.outboundTotal++;
          if (isAnswered) {
            const durationCalc =
              Math.abs(moment(startTime).diff(moment(), "seconds")) + duration;
            this.outboundComplete++;
            this.completedCalls++;
            this.callDuration += durationCalc;
            this.outboundTalkTime += durationCalc;
            agentCopy.outboundTalkTime += durationCalc;
          }
          this.$store.commit("queuemembers/updateItem", agentCopy);
        }
        this.activeOutbounds = this.activeOutbounds.filter(
          (item) => item.channel !== channel
        );
      }
    },

    updateAgentRefused(data) {
      const { peerName } = data;
      const agent = this.getQueueAgent(peerName);
      if (agent) {
        const agentCopy = { ...agent };
        agentCopy.refusedCalls = agentCopy.refusedCalls
          ? (agentCopy.refusedCalls = +agentCopy.refusedCalls + 1)
          : 1;
        this.$store.commit("queuemembers/updateItem", agentCopy);
      }
    },

    getPauseIcon(reason) {
      return pauseIcons(reason);
    },

    agentTooltipStatus(agent) {
      const { dnd, extStatus } = agent;

      //return immediately if agent is dnd
      if (dnd === "on") return "Do Not Disturb";

      //map for status to tooltip message
      const tooltipMap = {
        on: "Do Not Disturb",
        NOT_INUSE: "Idle",
        INUSE: "On A Call",
        RINGING: "Ringing",
        UNAVAILABLE: "Offline",
      };

      return tooltipMap[extStatus] ? tooltipMap[extStatus] : "Status Unknown";
    },

    async updateMemberLoginStatus(evt) {
      const { peer, loggedin } = evt;
      const member = this.getQueueAgent(peer);

      if (member) {
        const updateData = {
          member_device: member.member_device,
          loggedIn: +loggedin,
        };
        this.$store.commit("queuemembers/updateItem", updateData);

        //update local loggedIn state if user getting update is the actual agent
        if (this.user.hasOwnProperty("myExtension")) {
          if (member.member_device === this.user.myExtension.peerName) {
            this.$store.commit("setQueueLoggedIn", +loggedin === 1);
          }
        }
      }
    },

    //counter for caller hold times.
    updateHoldTimes() {
      const currentCallers = this.queueCallerList().data;
      const connectedCallers = this.currentCallList().data;

      //updates hold times if there are any to update
      const holdUpdate = currentCallers.map((item) => {
        return {
          channel: item.channel,
          wait: +item.wait + 1,
        };
      });
      if (holdUpdate.length) {
        this.$store.commit("queuecallers/updateItems", holdUpdate);
      }

      //updates call durations if there are any to update
      const connectedUpdate = connectedCallers.map((item) => {
        return {
          channel: item.channel,
          duration: +item.duration + 1,
        };
      });
      if (connectedUpdate.length) {
        this.$store.commit("currentcalls/updateItems", connectedUpdate);
      }
    },

    updatePauseTimes() {
      const pausedAgents = [...this.pausedAgents];
      const updateData = [];
      const agentsLength = pausedAgents.length;
      for (let i = 0; i < agentsLength; i++) {
        const theAgent = this.getQueueAgent(pausedAgents[i]);
        if (theAgent) {
          const { timezone } = this.user;
          const agentCopy = { ...theAgent };

          const userOffset = moment().utcOffset();
          const tzOffset = moment.tz(timezone).utcOffset();
          const realOffset = tzOffset - userOffset;
          const offsetMinutes = Math.abs(realOffset);

          const timeNow =
            realOffset < 0
              ? moment().subtract(offsetMinutes, "minutes")
              : moment().add(offsetMinutes, "minutes");

          const lastPause = moment(agentCopy.lastPauseTime);
          const diffInSeconds = timeNow.diff(lastPause, "seconds");
          agentCopy.lastPauseTime = timeNow.format("YYYY-MM-DD HH:mm:ss");
          agentCopy.pauseTime += +diffInSeconds;
          updateData.push(agentCopy);
        }
      }
      this.$store.commit("queuemembers/updateItems", updateData);
    },

/*    updateCallerPositions(leavePosition) {
      const updateCallers = this.queueCallerList({
        query: {
          position: { $gt: leavePosition },
        },
      }).data;
      const callersLength = updateCallers.length;
      for (let i = 0; i < callersLength; i++) {
        const updateData = {
          channel: updateCallers[i].channel,
          position: +updateCallers[i].position - 1,
        };
        this.$store.commit("queuecallers/updateItem", updateData);
      }
    },*/

    callSpyRequest(call, whisper) {
      const { channel, peername } = call;
      const splitChannel = channel.split("-");
      const channelPrefix = `${splitChannel[0]}-${splitChannel[1]}-`;

      const extension = peername.split("-")[0];
      const tenantCode = peername.split("-")[1];

      if (this.softphoneEnabled) {
        whisper
          ? globalEventBus.$emit("dialSoftphone", `*5${extension}`)
          : globalEventBus.$emit("dialSoftphone", `*6${extension}`);
      } else {
        const extensionNumber = this.user.myExtension.number;
        const channelName = `Local/${extensionNumber}@authenticated`;
        let reqBody = {
          reqType: "spy",
          whisper,
          channelName,
          account: this.user.myExtension.tenantCode,
          channelPrefix,
          callerId: extensionNumber,
          tenantCode,
          hostServer: this.userHostServer,
        };
        feathersClient.service("nats-actions-handler").create(reqBody);
      }

      //listen / coach user event
      this.$store.dispatch("userEvents/create", {
        event: whisper ? "Coach" : "Listen",
        extension,
      });
    },

    async withdrawCaller(call){

      const { channel, queueId } = call;

      try {
        const res = await fetch(`${apiV2Host}/queues/withdraw-caller?queueId=${queueId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${this.$store.state.auth.accessToken}`
          },
          body: JSON.stringify({ channel })
        });

        if(!res.ok) throw new Error(`Withdraw failed with status ${res.status}`);

      } catch (e) {
        console.log(e);
        this.$notify({
          title: "Failed",
          type: "error",
          message: "Failed to pick up call",
        });
      }
    },

    toggleLoggedIn(val) {
      const agentData = {
        member_device: this.user.myExtension.peerName,
        extensionId: this.user.myExtension.id,
      };
      this.handleToggle(val, agentData);
    },

    handleToggle(val, agent) {
      const { paused, member_device, extensionId } = agent;

      if (+paused) {
        this.pauseAgent = agent;
        this.pauseType = "unpause";
        this.toggleMemberPause();
      }

      //if global actions are enabled do make the global request to API
      if (this.globalQueueActions) {
        this.globalLoginToggle(val, agent);
        return;
      }

      const member = this.getQueueAgent(member_device);

      if (member) {
        const memberName = member.membername;

        const { id: queueId, name } = this.selectedQueue;

        feathersClient.service("nats-actions-handler").create({
          reqType: val ? "queueLogin" : "queueLogout",
          peerName: member_device,
          queueId,
          memberName,
          extensionId,
          server: this.userHostServer,
        });

        if (extensionId === this.user.myExtension.id) {
          // ⭐️ `QUEUE LOGIN` user event log ⭐️ //
          this.$store.dispatch("userEvents/create", {
            event: val ? "Queue Login" : "Queue Logout",
            queueId,
            name,
          });
          this.$store.commit("setQueueLoggedIn", val);
        } else {
          // ⭐️ `ADMIN QUEUE LOGIN` user event log ⭐️ //
          this.$store.dispatch("userEvents/create", {
            event: val ? "Admin Queue Login" : "Admin Queue Logout",
            queueId,
            queueName: name,
            agentName: memberName,
          });
        }
      }
    },

    globalLoginToggle(val, agent) {
      const { member_device, extensionId } = agent;

      const member = this.getQueueAgent(member_device);

      if (member) {
        const memberName = member.membername;

        //send the global request
        feathersClient.service("nats-actions-handler").create({
          reqType: val ? "globalQueueLogin" : "globalQueueLogout",
          peerName: member_device,
          memberName,
          extensionId,
        });

        if (extensionId === this.user.myExtension.id) {
          this.$store.commit("setQueueLoggedIn", val);
        }
      }
    },

    togglePause(val, reason = null) {
      const member = this.getQueueAgent(this.user.myExtension.peerName);

      if (member) {
        const { membername, member_device, member_interface } = member;

        //global actions enabled
        if (this.globalQueueActions) {
          //send the request
          const reqBody = {
            peerName: member_device,
            extensionId: this.user.myExtension.id,
            memberName: membername,
            interface: member_interface,
          };

          feathersClient.service("nats-actions-handler").create({
            reqType: val ? "globalQueuePause" : "globalQueueUnpause",
            paused: val ? 1 : 0,
            pauseReason: reason,
            ...reqBody,
          });

          return;
        }

        const reqBody = {
          peerName: member_device,
          extensionId: this.user.myExtension.id,
          queueId: this.selectedQueue.id,
          memberName: membername,
          interface: member_interface,
          server: this.userHostServer,
        };
        feathersClient.service("nats-actions-handler").create({
          reqType: val ? "queuePause" : "queueUnpause",
          paused: val ? 1 : 0,
          pauseReason: reason,
          ...reqBody,
        });

        const { id, name } = this.selectedQueue;

        this.$store.dispatch("userEvents/create", {
          event: val ? "Queue Pause" : "Queue Unpause",
          id,
          name,
        });
      }
    },

    handlePauseReasonChange(reason, agent) {
      console.log("reason changed", agent);

      if (reason === "Other") {
        this.pauseMember(agent);
        return;
      }

      this.pauseAgent = agent;
      this.pauseType = "pause";
      this.pauseReason = reason;
      this.processPause();
    },

    pushedConnected(item) {
      const { status, direction, cidnum } = item;

      if (status === "INUSE" && direction.length) {
        //filters out whether the call is actually connected to someone
        if (item.cidnum === "" || item.cidnum === "<unknown>") {
          return false;
        }

        if(item.cidnum.includes("SPY") || item.cidnum.includes("WHISPER")){
          return false;
        }

        //filters out feature code dialing
        return !(cidnum.substr(0, 1) === "*");
      } else {
        return false;
      }
    },

    checkCallExists(item) {
      const queryCall = this.currentCallList({
        query: { channel: item.channel },
      }).data;
      return !!queryCall.length;
    },

    dialCall(number) {
      globalEventBus.$emit("dialSoftphone", number);
    },

    pauseMember(agent) {
      this.pauseAgent = agent;
      this.pauseReasonVisible = true;
      this.pauseType = "pause";
    },

    unpauseMember(agent) {
      this.pauseAgent = agent;
      this.pauseType = "unpause";
      this.toggleMemberPause();
    },

    processPause() {
      this.toggleMemberPause();
      this.pauseReason = "";
      this.pauseMenuReason = "";
    },

    cancelPause() {
      this.pauseAgent = "";
      this.pauseReason = "";
      this.pauseReasonVisible = false;
    },

    toggleMemberPause() {
      let pauseReason = this.pauseReason;
      const val = this.pauseType === "pause" ? 1 : 0;

      const { id: queueId, name: queueName } = this.selectedQueue;
      const {
        membername: agentName,
        member_device,
        extensionId,
        member_interface,
      } = this.pauseAgent;

      if (!pauseReason.length || pauseReason === "Other") {
        pauseReason = this.otherPauseReason;
      }

      if (!pauseReason.length && val) {
        this.$notify({
          title: "Warning",
          message: "You Must Include A Pause Reason!",
          type: "warning",
        });
      } else {
        this.pauseReasonVisible = false;

        //global queue actions
        if (this.globalQueueActions) {
          this.globalMemberPause();
          return;
        }

        const reqBody = {
          peerName: member_device,
          extensionId,
          queueId,
          memberName: agentName,
          interface: member_interface,
          server: this.userHostServer,
        };
        feathersClient.service("nats-actions-handler").create({
          reqType: val ? "queuePause" : "queueUnpause",
          paused: val ? 1 : 0,
          pauseReason,
          ...reqBody,
        });

        if (+this.pauseAgent.extension === +this.user.myExtension.number) {
          this.$store.commit("setQueuePaused", val);
          this.$store.commit("setQueuePausedReason", pauseReason);
          this.$store.dispatch("userEvents/create", {
            event: val ? "Queue Pause" : "Queue Unpause",
            id: queueId,
            name: queueName,
          });
        } else {
          this.$store.dispatch("userEvents/create", {
            event: val ? "Admin Queue Pause" : "Admin Queue Unpause",
            queueId,
            queueName,
            agentName,
          });
        }

        this.pauseAgent = "";
      }
    },

    globalMemberPause() {
      let pauseReason = this.pauseReason;
      const val = this.pauseType === "pause" ? 1 : 0;

      const {
        membername: agentName,
        member_device,
        extensionId,
        member_interface,
      } = this.pauseAgent;

      if (!pauseReason.length || pauseReason === "Other") {
        pauseReason = this.otherPauseReason;
      }

      const reqBody = {
        peerName: member_device,
        extensionId,
        memberName: agentName,
        interface: member_interface,
      };
      feathersClient.service("nats-actions-handler").create({
        reqType: val ? "globalQueuePause" : "globalQueueUnpause",
        paused: val ? 1 : 0,
        pauseReason,
        ...reqBody,
      });

      if (+this.pauseAgent.extension === +this.user.myExtension.number) {
        this.$store.commit("setQueuePaused", val);
        this.$store.commit("setQueuePausedReason", pauseReason);
      }
    },

    async checkPastMidnight() {
      if (
        moment().format("YYYY-MM-DD") > this.pageLoadTime &&
        !this.statResetComplete
      ) {
        this.pageLoadTime = moment().format("YYYY-MM-DD");
        this.sessionStart = moment().format("YYYY-MM-DD HH:mm:ss");
        this.statResetComplete = true;
        if (this.selectedQueue.id) {
          this.$store.commit("queuemembers/clearList");
          this.pausedAgents = [];
          await this.querySummary();
          this.dashboardLoading = false;
        }
        if (this.user.hasOwnProperty("myExtension")) {
          //this will refresh the callers in line list and bust current connected calls.
          this.$store.commit("queuecallers/clearList");
          this.$store.commit("currentcalls/clearList");
          if (this.selectedQueue.id) {
            feathersClient.service("nats-actions-handler").create({
              reqType: "queueStatus",
              queueId: this.selectedQueue.id,
              server: this.userHostServer,
              tenantCode: this.selectedTenant.tenantCode,
            });
            this.getActiveCalls();
          }
        }
      } else if (
        moment().format("YYYY-MM-DD") === this.pageLoadTime &&
        this.statResetComplete
      ) {
        this.statResetComplete = false;
      }
    },

    updateAgentRinging(item) {
      const {
        cidnum,
        agentName,
        ishangup,
        isQueueEntry,
        channel,
        connectedlinename,
      } = item;

      if (isQueueEntry) {
        const agentName =
          connectedlinename === "unknown" ? "" : connectedlinename;
        this.$store.commit("queuecallers/updateItem", {
          channel,
          agentRinging: agentName,
        });
        return;
      }

      //clear agent name if hangup. if not update agent name
      if (ishangup) {
        const waitingCall = this.queueCallerList({
          query: {
            agentRinging: agentName,
          },
        }).data;

        if (waitingCall.length) {
          const { channel } = waitingCall[0];
          this.$store.commit("queuecallers/updateItem", {
            channel,
            agentRinging: "",
          });
        }
      } else {
        const waitingCall = this.queueCallerList({
          query: {
            calleridnum: cidnum,
          },
        }).data;

        if (waitingCall.length) {
          const { channel } = waitingCall[0];
          this.$store.commit("queuecallers/updateItem", {
            channel,
            agentRinging: agentName,
          });
        }
      }
    },

    buildStatsPayload(queueId) {
      let payload = {};
      const agents = this.findQueueMembers().data;
      payload[queueId.toString()] = {
        abandonRate: this.abandonRate,
        abandonedCalls: this.abandonedCalls,
        agents,
        callDuration: this.callDuration,
        callLeader: this.callLeader,
        completedCalls: this.completedCalls,
        hourlyMetrics: this.hourlyMetrics,
        inboundCalls: this.inboundCalls,
        inboundComplete: this.inboundComplete,
        inboundTalkTime: this.inboundTalkTime,
        longestWait: this.longestWait,
        outboundCalls: this.outboundCalls,
        outboundComplete: this.outboundComplete,
        outboundTalkTime: this.outboundTalkTime,
        servicelevelperf: this.servicelevelperf,
        shortestWait: this.shortestWait,
        tenantId: this.selectedTenant.id,
        totalCalls: this.totalCalls,
        totalSLA: this.totalSLA,
        waitTime: this.waitTime,
      };
      return payload;
    },

    async checkSessionLength() {
      const sessionLimitTime = moment(this.sessionStart)
        .add(3, "hours")
        .format("YYYY-MM-DD HH:mm:ss");
      if (moment().format("YYYY-MM-DD HH:mm:ss") > sessionLimitTime) {
        await this.querySummary();
        this.dashboardLoading = false;
        this.sessionStart = moment().format("YYYY-MM-DD HH:mm:ss");
      }
    },

    disableDND(user) {
      const { extension, extensionId, member_device } = user;
      //send the action to ami, userevent ami. this should result in an event firing the assures the store is accurate.
      const dndStatus = "";
      feathersClient
        .service("nats-actions-handler")
        .create({
          reqType: "setDND",
          peerName: member_device,
          dndStatus,
          extensionId,
        })
        .then(() => {
          if (extension === this.user.myExtension.number) {
            this.$store.commit("setUserDND", false);
            this.$store.dispatch("userEvents/create", {
              event: "Disabled DND",
            });
          } else {
            // ⭐️ `ADMIN DISABLE DND` user event log ⭐️ //
            this.$store.dispatch("userEvents/create", {
              event: "Admin Disable DND",
              extension,
            });
          }
        });
    },
  },
  created() {
    if (this.user) {
      this.queryQueues();
    }
  },
  mounted() {
    this.$store.commit("setQueueMode");
    const channelService = feathersClient.service("channel-memberships");

    //this is a counter to update the hold times for each caller in line
    this.holdCounter = setInterval(this.updateHoldTimes, 1000);
    this.pausePoller = setInterval(this.updatePauseTimes, 1000 * 30);
    this.resetPoller = setInterval(this.checkPastMidnight, 1000 * 60);
    this.sessionPoller = setInterval(this.checkSessionLength, 1000 * 60 * 20);

    //event listeners
    //queue member paused
    channelService.on("queueMemberPause", (item) => {
      this.updateMemberPause(item);
    });

    //user event that we can use to identify in real time if agent is logged in/out of the queue
    channelService.on("queueRefresh", (item) => {
      if (item.hasOwnProperty("loggedin")) {
        this.updateMemberLoginStatus(item);
      }
    });

    //call leaves the queue line
/*    channelService.on("queueCallerLeave", (item) => {
      this.$store.commit("queuecallers/removeItem", item.channel);
      this.updateCallerPositions(item.position);
    });*/

    //new caller joins the queue line
/*    channelService.on("queueCallerJoin", (item) => {
      item.wait = 0;
      this.$store.commit("queuecallers/addItem", item);
    });*/

    //initial entries in queue upon page load
    // replace queue entry handler
    // channelService.on("queueEntry", (item) => {
    //   console.log("item", item);
    //   // const call = this.getCallWaiting(item.channel);
    //   // console.log("found a call already", item);
    //   // console.log("queue entry event", item);
    //   // if (!call) {
    //   //   this.$store.commit("queuecallers/addItem", item);
    //   //   item.isQueueEntry = true;
    //   //   this.updateAgentRinging(item);
    //   // }
    // });

    //call connected to agent and leave in line list
/*    channelService.on("queueCallerConnected", (item) => {
      this.$store.commit("queuecallers/removeItem", item.channel);
      this.updateCallerPositions(item.position);
    });*/

    //agent complete call
    channelService.on("agentComplete", (item) => {
      this.updateAgentInbound(item);
      this.completedCalls++;
      this.inboundComplete++;
      this.inboundCalls++;
      this.totalCalls++;
      this.waitTime += +item.waitTime;
      this.shortestWait =
        +item.waitTime < this.shortestWait || this.shortestWait === 0
          ? +item.waitTime
          : this.shortestWait;
      this.longestWait =
        +item.waitTime > this.longestWait ? +item.waitTime : this.longestWait;
      this.callDuration += +item.duration;
      this.inboundTalkTime += +item.duration;
      if (+item.waitTime <= 30) {
        this.totalSLA++;
      }
      this.servicelevelperf = this.totalSLA / this.inboundComplete;
      this.abandonRate = this.abandonedCalls / this.inboundCalls;
    });

    //queue caller abandon
    channelService.on("queueAbandon", (item) => {
      this.abandonedCalls++;
      this.inboundCalls++;
      this.totalCalls++;
      this.abandonRate = this.abandonedCalls / this.inboundCalls;
    });

    //queue caller refused
    channelService.on("agentRefused", (item) => {
      const { extNum } = item;
      item.peerName = `${extNum}-${this.selectedTenant.tenantCode}`;
      this.updateAgentRefused(item);
    });

    //this is the event from another user that wants your stats
    channelService.on("showMeYourQueueStats", (evt) => {
      const { queueId, requestingUserId, requestingPeer } = evt;
      feathersClient.service("channel-memberships").create({
        isQueuePayload: true,
        queueId,
        requestingUserId,
        requestingPeer,
        payloadTimeStamp: this.payloadTimeStamp,
        queuePayload: this.buildStatsPayload(queueId),
      });
    });

    //monitor socket connection and reconnect to channel
    globalEventBus.$on("appReconnected", async () => {
      console.log("the app did reconnect");
      if (this.selectedQueue.id) {
        this.$store.commit("queuemembers/clearList");
        this.pausedAgents = [];
        await this.querySummary();
        this.sessionStart = moment().format("YYYY-MM-DD HH:mm:ss");
        this.dashboardLoading = false;
        await this.joinSocketChannel();
      }
      if (this.user.hasOwnProperty("myExtension")) {
        //this will refresh the callers in line list and bust current connected calls.
        this.$store.commit("queuecallers/clearList");
        this.$store.commit("currentcalls/clearList");
        if (this.selectedQueue.id) {
          feathersClient.service("nats-actions-handler").create({
            reqType: "queueStatus",
            queueId: this.selectedQueue.id,
            server: this.userHostServer,
            tenantCode: this.selectedTenant.tenantCode,
          });
          this.getActiveCalls();
        }
      }
    });

    //monitor queue login/logout toggle
    globalEventBus.$on("queueLoginToggled", (val) => {
      this.toggleLoggedIn(val);
    });

    //monitor queue paused toggle
    globalEventBus.$on("queuePauseToggled", (item) => {
      const { value, pauseReason } = item;
      this.togglePause(value, pauseReason);
    });

    //normal extension status events
    channelService.on("extensionStatus", (item) => {
      const {
        peername,
        ishangup,
        channel,
        isAnswered,
        cidname,
        status,
        direction,
        cidnum,
        event,
        channelState,
      } = item;
      const testExt = this.getQueueAgent(peername);

      //update caller information if this is a parking pick up.
      if (event === "ParkPickup") {
        const theCall = [
          ...this.currentCallList({ query: { cidnum: item.parkingSpace } })
            .data,
        ];
        if (theCall.length) {
          const channel = theCall[0].channel;
          this.$store.commit("currentcalls/updateItem", {
            channel,
            cidname: item.cidname,
            cidnum: item.cidnum,
          });
        }
        return;
      }

      if (testExt) {
        item.agentName = testExt.membername.replace("_", " ");
        if (ishangup) {
          this.updateAgentOutbound(testExt, channel, isAnswered);
          this.$store.commit("currentcalls/removeItem", channel);
          this.updateAgentRinging(item);
        } else {
          //if the agent is logged in we need to add this to active calls
          if (+testExt.loggedIn) {
            if (status === "RINGING") {
              this.updateAgentRinging(item);
            }
          }
          if (direction === "initiator" && cidnum !== "<unknown>") {
            this.activeOutbounds.push({
              startTime: moment().format("YYYY-MM-DD HH:mm:ss"),
              duration: 0,
              channel,
              cidnum,
            });
          }
        }
        this.updateMember(testExt, item);
      }
    });

    //listens for updates to extension availability
    channelService.on("notifyExtStatus", (item) => {
      const { peerName, status } = item;
      const testExt = this.getQueueAgent(peerName);
      if (testExt) {
        let updateData = { member_device: testExt.member_device };
        updateData.extStatus =
          status === "UNAVAILABLE" ? "UNAVAILABLE" : "NOT_INUSE";
        this.$store.commit("queuemembers/updateItem", updateData);
      }
    });
  },
  beforeDestroy() {
    //clean up the store items this view is dependent on.
    this.$store.commit("queues/clearList");
    this.$store.commit("currentcalls/clearList");
    this.$store.commit("queuecallers/clearList");
    this.$store.commit("unsetQueueMode");
    this.$store.commit("setQueues", []);
    this.$store.commit("setSelectedQueue", {});

    //leave queue real time channel and extension status channel
    const channelService = feathersClient.service("channel-memberships");
    channelService.remove(null, { query: { channelName: this.queueChannel } });
    channelService.remove(null, { query: { channelName: this.statusChannel } });
    this.removeListeners();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables";

.avatar-group {
  .status-light {
    bottom: 0px;
    right: -3px;
  }
}

.stat-number {
  font-size: 3em;
}

.stat-header {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1em;
  padding-bottom: 5px;
}

.stats-sub {
  display: flex;
  justify-content: space-between;
  align-self: flex-end;
  height: 45px;
}

.stats-flex-body {
  height: 200px;
  display: flex;
  flex-wrap: wrap;
  > * {
    flex-basis: 100%;
  }
}

.sub-stat-number {
  font: {
    weight: bold;
  }
}

.sub-stat-title {
  font-size: 0.85em;
}

.not-in-use {
  background: $voxo-pink;
}

.manager-action-button {
  width: 28px;
  height: 28px;
  padding: 1px;
  svg {
    width: 16px;
    margin: 1px 0px 0 0;
  }
}

.refused-call-button {
  padding: 5px;
  color: #fff;
}

.pause-icon {
  width: 18px;
}

.voxo-square-icon {
  width: 25px;
  height: 25px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 7px 0 5px 0;

  svg {
    flex: 0 0 20px;
    height: 20px;
    width: 20px;
    margin: auto;
  }
}

.agent-name {
  svg {
    margin-left: 3px;
  }
}

.tab-label {
  position: relative;
  display: flex;
}

.form-section-header {
  margin-top: 0;
  margin-bottom: 4px;
}

.call-badge {
  float: none;
}
</style>
